import { render, staticRenderFns } from "./NavigationPath.vue?vue&type=template&id=58cd5404&scoped=true&"
import script from "./NavigationPath.vue?vue&type=script&lang=js&"
export * from "./NavigationPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd5404",
  null
  
)

export default component.exports